export const APP_ID = 'latency'
export const APP_KEY = '6be0576ff61c053d5f9a3225e2a90f76'
